import React from "react";
import { Col, Pagination, Row } from "react-bootstrap";
import "./CustomPagination.scss";

interface CustomPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  totalResults: number;
}

const CustomPagination: React.FC<CustomPaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  totalResults,
}) => {
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, startPage + 4);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => onPageChange(i)}
          className="number-button"
        >
          {i}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  const isOnlyOnePage = totalPages === 1;
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages;

  return (
    <>
      <Row className="mb-3">
        <Col
          className="text-center fw-bold mt-3 mb-3"
          style={{ fontSize: "1.2rem" }}
        >
          {totalResults}{" "}
          <span> {totalResults === 1 ? "Resultado" : "Resultados"}</span>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xs="auto">
          <Pagination className="custom-pagination">
            <Pagination.Prev
              onClick={() => onPageChange(currentPage - 1)}
              disabled={isOnlyOnePage || isFirstPage}
              className={`nav-button prev ${
                isOnlyOnePage || isFirstPage ? "disabled" : ""
              }`}
            >
              Anterior
            </Pagination.Prev>
            {renderPageNumbers()}
            <Pagination.Next
              onClick={() => onPageChange(currentPage + 1)}
              disabled={isOnlyOnePage || isLastPage}
              className={`nav-button next ${
                isOnlyOnePage || isLastPage ? "disabled" : ""
              }`}
            >
              Siguiente
            </Pagination.Next>
          </Pagination>{" "}
        </Col>
      </Row>
    </>
  );
};

export default CustomPagination;
